import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../config/api';

export function useHomeContent() {
  const { token } = useAuth();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchContent = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/home-content`);
      if (!res.ok) throw new Error('Failed to fetch home content');
      setContent(await res.json());
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchContent(); }, [fetchContent]);

  const updateContent = useCallback(async (data) => {
    const res = await fetch(`${API_BASE}/api/home-content`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to update home content');
    const updated = await res.json();
    setContent(updated);
    return updated;
  }, [token]);

  return { content, loading, error, fetchContent, updateContent };
}
